import { DeepMutable, Properties } from "@util/types";
import Category from "./Category";
import { RootProductId } from "./Product";
import _ from "lodash";

export default class BudgetCategory extends Category {
	constructor(
		props: Omit<DeepMutable<Properties<BudgetCategory>>, "product">,
		productId: RootProductId
	) {
		super(props, productId);
		this.maxAmountMonth = props.maxAmountMonth;
		this.subCategories = props.subCategories.map(
			(c) => new Category(c, productId)
		);
	}

	static fromJson(data: any, productId: RootProductId) {
		return new BudgetCategory(
			{
				...data,
				subCategories: _.sortBy(
					data.subCategories.map((catData: any) =>
						Category.fromJson(catData, productId)
					),
					(category) => category.name.toLowerCase()
				),
			},
			productId
		);
	}

	readonly maxAmountMonth: number;

	readonly subCategories: Category[];

	findCategory(categoryId: string): BudgetCategory | Category | undefined {
		return [this, ...this.subCategories].find((c) => c.id === categoryId);
	}
}
